module.exports = __webpack_public_path__ + "img/tag-3-7~10.e7676d36.svg";